import { type ECharts } from 'echarts';
import merge from 'deepmerge';
import { type DataItem, type Option } from './DynamicDvScatterHelper';

export function getFlatData(data: Option[]): DataItem[] {
  const result: DataItem[] = [];
  data.forEach(timeItem => {
    timeItem.series.forEach(seriesItem => {
      result.push(
        ...seriesItem.data.map(d => {
          return {
            ...d,
            seriesName: seriesItem.name
          } as DataItem;
        })
      );
    });
  });
  return result;
}

// 获取单点的Zrender实例
export function getItemGraphicEl(ecIns: ECharts, seriesIndex: number, dataIndex: number): Element {
  const series = ecIns.getModel().getSeriesByIndex(seriesIndex);
  return series.getData().getItemGraphicEl(dataIndex) as Element;
}

export function optionDelayHandle(option: Option, stepAnimationDuration?: number) {
  const optionCloned = merge({}, option);
  const delay = stepAnimationDuration ? idx => idx * stepAnimationDuration : 0;
  optionCloned.series.forEach(seriesItem => {
    if (!seriesItem.isHistory) {
      return;
    }
    seriesItem.animationDelay = delay;
    seriesItem.animationDelayUpdate = delay;
  });
  return optionCloned;
}

export function axisRangeHandle(
  options: Option[],
  range: { xRange: [number, number]; yRange: [number, number] }
) {
  const { xRange, yRange } = range;
  options.forEach(option => {
    const xAxis = Array.isArray(option.xAxis) ? option.xAxis : [option.xAxis];
    const yAxis = Array.isArray(option.yAxis) ? option.yAxis : [option.yAxis];
    xAxis.forEach(xAxisItem => {
      const [xMin, xMax] = xRange;
      xAxisItem.min = xMin;
      xAxisItem.max = xMax;
    });
    yAxis.forEach(yAxisItem => {
      const [yMin, yMax] = yRange;
      yAxisItem.min = yMin;
      yAxisItem.max = yMax;
    });
  });
}
